module.exports = __webpack_public_path__ + "img/icon-phone-primary.da0e0063.svg";